import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { X, Sparkles, ArrowRight } from 'lucide-react';

export const FloatingOpMaat = ({ variant = 'tab' }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);

  if (!isVisible) return null;

  // Variant 1: Verticale Tab (Links)
  if (variant === 'tab') {
    return (
      <div className="fixed left-0 top-36 z-40 group">
        <div className="bg-earth-brown text-white shadow-2xl flex items-center overflow-hidden">
          <div className="p-4 pr-3">
            <div className="flex items-center gap-3">
              <Sparkles className="w-5 h-5 text-terra-beige flex-shrink-0" />
              <p className="font-sweet-sans text-xs leading-relaxed flex-1">
                Speciaal verzoek? Wij creëren het voor jou
              </p>
              <Link 
                to="/custom-basket"
                className="inline-flex items-center text-white hover:text-terra-beige transition-colors duration-200 group flex-shrink-0"
                aria-label="Ga naar Op Maat pagina"
              >
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" />
              </Link>
            </div>
          </div>
          <button
            onClick={() => setIsVisible(false)}
            className="px-2 py-1 hover:bg-white/10 transition-colors self-start"
            aria-label="Sluiten"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    );
  }

  // Variant 2: Expandeerbare Button
  if (variant === 'expandable') {
    return (
      <div 
        className="fixed left-4 top-1/2 -translate-y-1/2 z-40"
        onMouseEnter={() => setIsExpanded(true)}
        onMouseLeave={() => setIsExpanded(false)}
      >
        <div className={`bg-earth-brown text-white shadow-2xl rounded-none transition-all duration-300 ${
          isExpanded ? 'pl-5 pr-12 py-4' : 'p-4'
        } relative`}>
          {!isExpanded ? (
            <Sparkles className="w-6 h-6 text-terra-beige" />
          ) : (
            <div className="whitespace-nowrap">
              <p className="font-sweet-sans text-xs mb-2">
                Speciaal verzoek?
              </p>
              <Link 
                to="/custom-basket"
                className="text-white font-sweet-sans text-xs uppercase tracking-wider underline hover:text-white/80 transition-colors font-bold"
              >
                Op Maat
              </Link>
            </div>
          )}
          {isExpanded && (
            <button
              onClick={() => setIsVisible(false)}
              className="absolute right-2 top-2 p-1 hover:bg-white/10 rounded-none transition-colors"
              aria-label="Sluiten"
            >
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>
    );
  }

  // Variant 3: Compact Banner (Links)
  if (variant === 'compact') {
    return (
      <div className="fixed left-4 top-1/2 -translate-y-1/2 z-40">
        <div className="bg-white border-2 border-earth-brown shadow-2xl  p-4 max-w-[200px] relative">
          <button
            onClick={() => setIsVisible(false)}
            className="absolute -top-2 -right-2 bg-earth-brown text-white rounded-none p-1 hover:bg-earth-brown/80 transition-colors shadow-lg"
            aria-label="Sluiten"
          >
            <X className="w-4 h-4" />
          </button>
          <div className="flex flex-col items-center text-center gap-2">
            <Sparkles className="w-8 h-8 text-terra-beige" />
            <p className="font-sweet-sans text-xs text-almost-black/80 leading-relaxed">
              Speciaal verzoek?
            </p>
            <Link 
              to="/custom-basket"
              className="text-earth-brown font-sweet-sans text-xs uppercase tracking-wider underline hover:text-earth-brown/70 transition-colors font-bold"
            >
              Op Maat
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return null;
};
